import React from 'react';
import './SplashScreen.less';

const SplashScreen = ({ overlay = false }) => {
  const className = overlay ? 'splash-screen splash-screen--overlay' : 'splash-screen';
  return (
    <div className={className} role="status" aria-live="polite">
      <img src="/assets/LS-Logo.svg" alt="Liquid Spirit Logo" className="splash-logo" />
    </div>
  );
};

export default SplashScreen;
